import { styled, css } from 'styled-components';

import { CheckboxProps } from './types';

export const CheckboxLabel = styled.label<{ isDisabled: boolean; isCentered: boolean }>`
  display: flex;
  gap: var(--spacing-4);
  align-items: flex-start;
  cursor: pointer;

  ${({ isCentered }) =>
    isCentered &&
    css`
      align-items: center;
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.3;
    `}
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;

  &::before {
    content: '\\200B';
  }
`;

export const IconWrapper = styled.div`
  opacity: 0;

  svg {
    display: block;
  }
`;

export const CheckBoxText = styled.div<Pick<CheckboxProps, 'isSmall'>>`
  ${({ isSmall }) =>
    isSmall &&
    css`
      font: var(--font-body-small--regular);
    `}
`;

export const CheckboxReplacement = styled.div<{
  isSelected: boolean;
  isFocusVisible: boolean;
  isDisabled: boolean;
  hasError: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border: 1px solid var(--color-numa-black--200);
  color: var(--color-white);

  @media only screen and (max-width: 450px) {
    width: 20px;
    height: 20px;
  }

  &:hover {
    border-color: var(--color-numa-black--400);
  }

  ${({ isFocusVisible }) =>
    isFocusVisible &&
    css`
      box-shadow: var(--shadow--focus-ring);
      border-color: var(--color-primary);
    `}

  ${({ isSelected }) =>
    isSelected &&
    css`
      border-color: var(--color-numa-black--400);
      background-color: var(--color-numa-black--400);

      ${IconWrapper} {
        opacity: 1;
      }
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.3;
    `}

  ${({ hasError }) =>
    hasError &&
    css`
      border-color: var(--color-numa-red--200);
    `}
`;
